import { withExtras } from './withExtras';
export function withExtra(key, value) {
    var _a;
    return withExtras((_a = {}, _a[key] = value, _a));
}
//# sourceMappingURL=withExtra.js.map